// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { TextList, Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { ModuleAdditionalRows } from '../../_contracts';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let TeaserBoxInnerGrid6TTextList = class TeaserBoxInnerGrid6TTextList extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            isPremium: this.teaserBoxConfig.isPremium,
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            showAuthorAvatar: false,
            showAuthorName: false,
            showCategory: false,
            showPublicationDate: this.teaserBoxConfig.showPublicationDate,
            showTitle: true,
            size: TileSize.S,
            titleOnImage: false,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
        this.listConfig = {
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
    }
    get tilesOffset() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.addOne:
                return 9;
            case ModuleAdditionalRows.addTwo:
                return 12;
            default:
                return 6;
        }
    }
    get gridStyle() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.None:
                return 'teaser-box__list-wrapper';
            case ModuleAdditionalRows.addOne:
                return 'teaser-box__list-wrapper-three-rows';
            case ModuleAdditionalRows.addTwo:
                return 'teaser-box__list-wrapper-four-rows';
            default:
                return 'teaser-box__list-wrapper';
        }
    }
};
TeaserBoxInnerGrid6TTextList.moduleVersion = TeaserBoxVersion['6T-text-list'];
TeaserBoxInnerGrid6TTextList = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid6TTextList',
        components: { InnerGridWrapper, TextList, Tile },
        template: `
    <InnerGridWrapper>
      <template v-if="articles && articles.length">
        <!-- Tiles -->
        <Tile v-for="article in articles.slice(0, tilesOffset)" :key="article.id"
              v-bind="{ ...tileConfig, article, fallbackImage, windowService, isLazy, isMobile }" />

        <!-- TextList -->
        <div :class="gridStyle">
          <TextList v-bind="{ readMoreLink, listConfig }" :articles="articles.slice(tilesOffset)" />
        </div>
      </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGrid6TTextList);
export { TeaserBoxInnerGrid6TTextList };
